import { render, staticRenderFns } from "./MarkdownEditor.vue?vue&type=template&id=4b87205a&scoped=true"
import script from "./MarkdownEditor.vue?vue&type=script&lang=js"
export * from "./MarkdownEditor.vue?vue&type=script&lang=js"
import style0 from "./MarkdownEditor.vue?vue&type=style&index=0&id=4b87205a&prod&lang=less"
import style1 from "./MarkdownEditor.vue?vue&type=style&index=1&id=4b87205a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b87205a",
  null
  
)

export default component.exports